import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import Halo from "../../../../Assets/images/flawless-img/shop-by-style/halo.png";
import Solitaire from "../../../../Assets/images/flawless-img/shop-by-style/solitaire.png";
// import ThreeStone from "../../../../Assets/images/flawless-img/shop-by-style/3 stone.webp";
import SingleRow from "../../../../Assets/images/flawless-img/shop-by-style/single-row.png";
import Vintage from "../../../../Assets/images/flawless-img/shop-by-style/vintage.png";
import ByPass from "../../../../Assets/images/flawless-img/shop-by-style/bypass.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
import SlickLeft from "../../../../Assets/images/flawless-img/left-arrow.svg";
import SlickRight from "../../../../Assets/images/flawless-img/right-arrow.svg";
import { Je_welryspelling } from "../../../../Helpers/request";
import { it } from "date-fns/locale";

const ShopRingByStyle = () => {
  let settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    accessibility: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    prevArrow: <Image src={SlickLeft} alt="" />,
    nextArrow: <Image src={SlickRight} alt="" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true,
          dots: false,
        },
      },
    ],
  };
  const styleData = [
    {
      name: "Solitaire",
      image: Solitaire,
      url: "/ringsettings/style=Solitaire",   
    },
    {
      name: "Halo",
      image: Halo,    
      url: "/ringsettings/style=Halo",
    },    
    {
      name: "Single Row",
      image: SingleRow,
      url: "/ringsettings/style=Single%20Row",
    },
    {
      name: "Vintage",
      image: Vintage,
      url: "/ringsettings/style=Vintage",
    },
    {
      name: "Bypass",
      image: ByPass,
      url: "/ringsettings/style=Bypass",
    },  
  ]

  return (
    <section className="shop-ring-by-style section-space">
      <Container fluid className="showcase-container">
        <Heading className="text-center">
          <h2>Our most popular ring designs</h2>
          {/* <p>Explore  {Je_welryspelling}  Collections by Style and Make a Statement.</p> */}
        </Heading>

        <Slider {...settings2} className="f_ring_style_slider">
         {
          styleData.map((item, index) => (
            <div className="F_style_item_outer">
<div className="item">
            <Link to={item.url}>
              <Image src={item.image} alt={item.name} />
            </Link>
            <Link to={item.url}>{item.name}</Link>
          </div>
            </div>
            
          ))
         } 
          {/* <div className="item">
            <Link to="/ringsettings/style=Solitaire">
              <Image src={Solitaire} alt="Solitaire" />
            </Link>
            <Link to="/ringsettings/style=Solitaire">Solitaire</Link>
          </div>
     
          <div className="item">
            <Link to="/ringsettings/style=Single Row">
              <Image src={SingleRow} alt="SingleRow" />
            </Link>
            <Link to="/ringsettings/style=Single Row">Single Row</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Multirow">
              <Image src={Vintage} alt="Vintage" />
            </Link>
            <Link to="/ringsettings/style=Multirow">Multirow</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Bypass">
              <Image src={ByPass} alt="Bypass" />
            </Link>
            <Link to="/ringsettings/style=Bypass">Bypass</Link>
          </div>
          <div className="item">
            <Link to="/ringsettings/style=Solitaire">
              <Image src={Solitaire} alt="Solitaire" />
            </Link>
            <Link to="/ringsettings/style=Solitaire">Solitaire</Link>
          </div> */}
        </Slider>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
